import { environment } from '../../environments/environment';
export const actionButtonConfiguration = [
    {
        "sendPrescriptionLink": [
            {
                "role": "admin",
                "status": [1,2,9],
                // "business":["3","4"]
            },
            {
                "role": "superadmin",
                "status": [25,26,9,300,1001]
            }
        ],
        "uploadPrescriptionLink": [
            {
                "role": "admin",
                "status": [1,2,9]
            },
            {
                "role": "superadmin",
                "status": [2,25,1001]
            }
        ],
        "viewPrescriptionLink": [
            {
                "role": "admin",
                "status": [-1]
            },
            {
                "role": "superadmin",
                "status": [-1]
            }
        ],
        "uploadReport": [
            {
                "role": "admin",
                "status": [303]
            },
            {
                "role": "superadmin",
                "status": [303],
				// "forSpacialOnly":[
				// 	"isUCDOrder"
				// ]
            }
        ],
        "uploadReportReady": [
            {
                "role": "admin",
                "status": [301]
            },
            {
                "role": "superadmin",
                "status": [301]
            }
            
        ],
        "viewReport": [
            {
                "role": "admin",
                "status": [-1]
            },
            {
                "role": "superadmin",
                "status": [-1]
            }
        ],
        "viewPaymentLink": [
            {
                "role": "superadmin",
                "status": [-1]
            }
        ],
        "orderComplete": [
            {
                "role": "admin",
                "status": [302,303]
            },
            {
                "role": "superadmin",
                "status": [302,303,902],
				// "forSpacialOnly":[
				// 	"isUCDOrder"
				// ]
            }
        ],
        "orderCancel": [
            {
                "role": "superadmin",
                "status": [25,26,0,1,2,7,9,300,1001,301,902]
            }
        ],
        "orderReject": [
            {
                "role": "admin",
                "status": [1,2,301]
            },
            {
                "role": "superadmin",
                "status": [1,2,301,6],
				"forSpacialOnly":[
					"isUCDOrder"
				]
            }
        ],
        "reAssign": [
            {
                "role": "superadmin",
                "status": [26,0,9,300,1001]
            }
        ],
        "addItem": [
            {
                "role": "superadmin",
                "status": [26,0,9,300,1001]
            }
        ],
        "deleteItem": [            
            {
                "role": "superadmin",
                "status": [25,26,0,9,300,1001]
            }
        ],
        "confirmScheduleDate": [            
            {
                "role": "superadmin",
               "status": [25,26,7,0,1001]
            }
        ],
        "reScheduleOrder": [
            {
                "role": "superadmin",
                "status": [1,2,7,9,300,505]
            }
        ],

        "sentOTP": [
            {
                "role": "superadmin",
                "status": [1,2]
            }
        ],
        "resentOTP": [
            {
                "role": "admin",
                "status": [1,2]
            },
            {
                "role": "superadmin",
                "status": [1,2],
				"forSpacialOnly":[
					"isUCDOrder"
				]
            }
        ],
        "verifyOTP": [
            {
                "role": "admin",
                "status": [1,2,7]
            },
            {
                "role": "superadmin",
                "status": [1,2,7],
				"forSpacialOnly":[
					"isUCDOrder"
				]
            }
        ],
        "tenantCodesDrl": environment.tenantCodesDrl,
        "orgCodesDrl":  environment.orgCodesDrl        
    }
]